// extracted by mini-css-extract-plugin
export default {"verizonBanner":"styles_verizonBanner__iDRA3","closeCircle":"styles_closeCircle__mH+oe"};